import React, { useMemo } from 'react';
import { ShoppingCartOutlined } from '@ant-design/icons';
import { useCart } from './useCart';
import { Badge } from 'antd';
import { Link } from 'gatsby';

export const CartIcon = () => {
  const { items } = useCart();
  const totalItems = useMemo(
    () => items.reduce((acc, item) => acc + item.quantity, 0),
    [items],
  );

  return (
    <Link to="/cart" className="relative inline-flex items-center">
      <Badge
        className="absolute"
        style={{ top: 3, right: -20 }}
        count={totalItems}
      />
      <ShoppingCartOutlined style={{ fontSize: 30 }} />
    </Link>
  );
};
